// extracted by mini-css-extract-plugin
module.exports = {"trustpilotWidgetContainer":"trustpilot-widget_trustpilotWidgetContainer__8upWd","linkOverlay":"trustpilot-widget_linkOverlay__OOvW0"};